import axiosInstance from "./axiosInstance";

const API_BASE_URL = process.env.REACT_APP_CHECKIN_API_URL ?? "https://dev-api.checkin.degencoinflip.com/v1";

interface Wallet {
  walletId: string;
  type: "Primary" | "Sub";
  createdAt: string;
}

interface GenerateKycConnectResponse {
  payload: {
    id: string;
  };
}

interface GetWalletsResponse {
  payload: Wallet[];
}

/**
 * Generates a KYC connection with the provided auth token.
 *
 * @returns The generated connection ID
 */
export const generateKycConnect = async (): Promise<string> => {
  const response = await axiosInstance.post<GenerateKycConnectResponse>(
    `${API_BASE_URL}/kyc-connect/generate`
  );
  return response.data.payload.id;
};

/**
 * Gets all wallets associated with a primary wallet
 */
export const getAllWallets = async (primaryWalletId: string): Promise<Wallet[]> => {
  const response = await axiosInstance.get<GetWalletsResponse>(
    `${API_BASE_URL}/kyc-profile/wallet/${primaryWalletId}/sub-wallets`
  );
  return response.data.payload;
};

/**
 * Removes a sub-wallet from KYC profile
 */
export const removeSubWallet = async (subWalletId: string): Promise<void> => {
  const response = await axiosInstance.delete(
    `${API_BASE_URL}/kyc-profile/remove/${subWalletId}`
  );
  return response.data.payload;
};

/**
 * Registers a wallet using a connection code
 */
export const registerWalletByCode = async (
  primaryWalletId: string,
  code: string
): Promise<void> => {
  const response = await axiosInstance.post(
    `${API_BASE_URL}/kyc-connect/wallet/${primaryWalletId}/code/${code}/register`
  );
  return response.data.payload;
};

/**
 * Registers a wallet using a connection code
 */
export const registerWalletByCodeOnly = async (
  code: string
): Promise<void> => {
  const response = await axiosInstance.post(
    `${API_BASE_URL}/kyc-connect/${code}/register`
  );
  return response.data.payload;
};

